import { useCallback } from 'react';
import { useMapContext } from '../../../context/map';
import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';

interface IResult {
  onZoomIn: () => void;
  onZoomOut: () => void;
}
type TUseControlHandlers = () => IResult;

const useControls: TUseControlHandlers = () => {
  const { map } = useMapContext();

  const onZoomIn = useCallback(() => {
    if (map) {
      map.zoomIn();
      logAmplitudeEvent('clickZoomIn');
    }
  }, [map]);

  const onZoomOut = useCallback(() => {
    if (map) {
      map.zoomOut();
      logAmplitudeEvent('clickZoomOut');
    }
  }, [map]);

  return { onZoomIn, onZoomOut };
};

export default useControls;
